// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"CheckboxInput_CheckboxInput__1-svY","Inline":"CheckboxInput_Inline__1bOKn"};